import axios from 'axios';

// Add a request interceptor
/*axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    console.log(config);
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });
*/

axios.interceptors.response.use(function (response) {
    //console.log('Intercept Response', response);
    return response;
}, function (error) {
    const status = error.response.status;
    const data = error.response.data;

    if (status && ((status === 500 && data && data.payload && data.payload === "Autenticação inválida") || status === 403)) {
        localStorage.removeItem('config.savedUser');
        document.location = document.location.href.split('/').slice(0,-1).join('/')
        return;
    } else {
        return Promise.reject(error);
    }
});

export default axios;